import { Box, Flex, HStack, Table, TableContainer, Tbody, Text, Th, Thead, Tr, useDisclosure } from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { AiOutlinePlus } from 'react-icons/ai'
import { FaSearch } from 'react-icons/fa'
import CreateShelfModal from '../Components/CreateShelfModal'
import Input from '../Components/Input'
import Pagination from '../Components/Pagination'
import Preloader from '../Components/Preloader'
import SearchComponent from '../Components/SearchComponent'
import TableRow from '../Components/TableRow'
import MainLayout from '../Layouts/Index'
import { ConfirmPickUp, GetAllProductShelf, ReadAllProcurementDeviceAssignment, ReadAllRequest } from '../Utils/ApiCalls'
import Seo from '../Utils/Seo'
import PrintPickUp from './PrintPickUp'
import { configuration } from '../Utils/config'
import UpdateQty from '../Components/UpdateQty'
import UpdatePickUpQty from '../Components/UpdatePickUpQty'
import UpdateDeviceAssingmentProcument from '../Components/UpdateDeviceAssingmentProcument'
import MoreProcurement from '../Components/MoreProcurement'

export default function DeviceAssignmentProcurement() {
    const { isOpen, onOpen, onClose } = useDisclosure();


    const [ModelState, setModelState] = useState(false);
    const [PrintMode, setPrintMode] = useState(false);

    const [SearchText, setSearchText] = useState("");
    const [SingleData, setSingleData] = useState(false);

    const [Data, setData] = useState([]);
    const [CurrentPage, setCurrentPage] = useState(1);
    const [PostperPage, setPostperPage] = useState(configuration.sizeperpage);
    const [PreLoader, setPreLoader] = useState(true);

    const [OpenModal, setOpenModal] = useState(false);


    //get current post

    const indexOfLastSra = CurrentPage * PostperPage;
    const indexOfFirstSra = indexOfLastSra - PostperPage;
    const currentData = Data?.slice(indexOfFirstSra, indexOfLastSra);
    //change page 
    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber)
    }
    const [Result, setResult] = useState([]);
    const [TotalData, setTotalData] = useState([]);
    const [TransferId, setTransferId] = useState("");




    const GetAllRequest = async () => {
        let result = await ReadAllProcurementDeviceAssignment()

        console.log("result request", result);

        if (result.status === true) {
            setData(result.queryresult.sraiirdetails)
            setTotalData(result.queryresult.totalsraiirdetails
            )
            setPreLoader(false)
        }
    }

    const updateData = (id) => {

        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })

        setSingleData(singleInfo)
        
        onOpen()
    }

    const ViewMore  = (id) => {

        let singleInfo = Data.filter((item, i) => {
            return item._id === id
        })

        setSingleData(singleInfo)
        setModelState(true)
      
    }






    useEffect(() => {
        GetAllRequest()
    }, [isOpen, ModelState, OpenModal]);
    return (

        <MainLayout>
            {
                PreLoader && (

                    <Preloader />
                )
            }
            <Seo title="Pick up" description='EKO IMS - Pick up' />
            <Flex justifyContent={"flex-end"} flexWrap="wrap" fontWeight={"500"} >


                <Text textTransform="capitalize">Total Product Request - {TotalData}</Text>

            </Flex>


            <SearchComponent SearchText={SearchText} setSearchText={(e) => setSearchText(e.target.value)} Keywords={"Batch id,StaffMail, ProductName"} />
            <Box height="70vh" minH={"70vh"} overflow="scroll" w="100%" _hover={{ overflow: "auto" }} bg="blue.blue300" mt="32px" rounded={"8px"}>

                <TableContainer mt="32px" overflowX="auto" color="#fff">

                    <Table variant='simple' size='sm' >
                        <Thead>
                            <Tr>
                                <Th color="#fff">S/N</Th>
                                <Th color="#fff">Sra Number</Th>
                                <Th color="#fff">for device_assignment</Th>
                                <Th color="#fff">Created at</Th>
                                <Th color="#fff">Status</Th>
                                <Th color="#fff">View More</Th>
                                <Th color="#fff">Update</Th>




                            </Tr>
                        </Thead>


                        <Tbody>
                            {
                                SearchText === "" ? (
                                    currentData?.map((item, i) => (
                                        <TableRow
                                            type={"device assignment procurement"}
                                            key={i}
                                            sn={i + 1}
                                            status={item.deviceassigmentstatus}
                                            sraNo={item.sranumber}
                                            isDeviceAssignment={item.fordeviceassignment}
                                            dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}
                                            update={()=>updateData(item._id)}
                                            onClick={()=>ViewMore(item._id)}

                                        />
                                    ))
                                ) : (
                                    SearchText !== "" && Data.filter(item => item.batchid?.includes(SearchText) || item.shelfid.productname?.toLowerCase().includes(SearchText.toLowerCase()) || item.staffemail?.includes(SearchText)).length > 0 ? (

                                        Data?.filter(item => item.batchid?.includes(SearchText) || item.staffid?.includes(SearchText) || item.staffemail?.includes(SearchText)).

                                            map((item, i) => (
                                                <TableRow
                                                    type={"device assignment procurement"}
                                                    key={i}
                                                    sn={i + 1}
                                                    status={item.deviceassigmentstatus}
                                                    ticketNo={item.batchid}
                                                    isDeviceAssignment={item.fordeviceassignment}
                                                    dateReceived={moment(item.requestdate).format('DD/MM/YYYY')}
                                                    update={()=>updateData(item._id)}
                                                    onClick={()=>ViewMore(item._id)}

                                                />
                                            ))
                                    ) : (
                                        <Text textAlign={"right"} mt="32px" color="#ddd">*--No result found--*</Text>

                                    )

                                )


                            }
                        </Tbody>

                    </Table>
                </TableContainer>

                <Pagination postPerpage={PostperPage} currentPage={CurrentPage} totalPosts={Data?.length} paginate={paginate} />
                <UpdatePickUpQty SingleData={SingleData} state="request" isOpen={OpenModal} onClose={() => setOpenModal(false)} />



            </Box>

            <UpdateDeviceAssingmentProcument isOpen={isOpen} onClose={onClose} singleItem={SingleData} />
            <MoreProcurement isOpen={ModelState} onClose={()=>setModelState(false)} singleData={SingleData} />


        </MainLayout>
    )
}
